// extracted by mini-css-extract-plugin
export var logo = "Logo-module--logo--1ZksN";
export var link = "Logo-module--link--3Pol0";